// Mutations
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const CHANGE_NOTIFICATION_STATE = 'CHANGE_NOTIFICATION_STATE'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'

// States
export const NOTIFICATION_STATE_OPENING = 'NOTIFICATION_STATE_OPENING'
export const NOTIFICATION_STATE_SHOWING = 'NOTIFICATION_STATE_SHOWING'
export const NOTIFICATION_STATE_CLOSING = 'NOTIFICATION_STATE_CLOSING'

// Types
export const NOTIFICATION_TYPE_ERROR = 'NOTIFICATION_TYPE_ERROR'
export const NOTIFICATION_TYPE_WARNING = 'NOTIFICATION_TYPE_WARNING'
export const NOTIFICATION_TYPE_SUCCESS = 'NOTIFICATION_TYPE_SUCCESS'

export const NOTIFICATION_TYPES = [
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_SUCCESS
]



// WEBPACK FOOTER //
// ./src/store/modules/notifications/types.js